export default "__VITE_ASSET__CpGHnSti__"